import { mutationOptions } from '@tanstack/react-query'
import { exportPlatformStocks, importPlatformStocks } from './platform-stocks.mutations'

export const exportPlatformStocksOptions = (params?: {
  storeReference?: string
  internalCategoryIds?: number[]
}) =>
  mutationOptions({
    mutationFn: () => exportPlatformStocks(params),
  })

export const importPlatformStocksOptions = () =>
  mutationOptions({
    mutationFn: importPlatformStocks,
  })
